/* ═══════════════════════════════════════════════════════════════════════
   NoteFlow — auth-firm.ts
   Firm profile (default company info applied to new projects).
   ═══════════════════════════════════════════════════════════════════════ */

import { getUserKey } from './config';
import { el, elInput } from './utils';
import { cloudSaveUserData } from './data';

function loadFirmProfile(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem('noteflow-firmprofile-' + getUserKey()) || '{}') || {}; }
  catch (_e) { return {}; }
}

function saveFirmProfile(profile: Record<string, string>): void {
  localStorage.setItem('noteflow-firmprofile-' + getUserKey(), JSON.stringify(profile));
  cloudSaveUserData('firmProfile', profile);
}

export function openFirmProfile(): void {
  const p = loadFirmProfile();
  const fpFields: [string, string][] = [
    ['fp-entity-type', p.entityType || ''],
    ['fp-state', p.state || ''],
    ['fp-basis', p.basis || ''],
    ['fp-depreciation', p.depreciation || ''],
    ['fp-tax-status', p.taxStatus || ''],
    ['fp-inventory', p.inventory || ''],
    ['fp-useful-lives', p.usefulLives || ''],
    ['fp-revenue-rec', p.revenueRec || ''],
    ['fp-cash-equiv', p.cashEquiv || ''],
  ];
  fpFields.forEach(function ([id, val]) {
    const fpEl = elInput(id);
    if (fpEl) fpEl.value = val;
  });
  el('firm-profile-modal')?.classList.add('open');
}

export function closeFirmProfile(): void {
  el('firm-profile-modal')?.classList.remove('open');
}

export function saveFirmProfileFromForm(): void {
  const p: Record<string, string> = {
    entityType: elInput('fp-entity-type')?.value ?? '',
    state: elInput('fp-state')?.value ?? '',
    basis: elInput('fp-basis')?.value ?? '',
    depreciation: elInput('fp-depreciation')?.value ?? '',
    taxStatus: elInput('fp-tax-status')?.value ?? '',
    inventory: elInput('fp-inventory')?.value ?? '',
    usefulLives: elInput('fp-useful-lives')?.value ?? '',
    revenueRec: elInput('fp-revenue-rec')?.value ?? '',
    cashEquiv: elInput('fp-cash-equiv')?.value ?? '',
  };
  saveFirmProfile(p);
  closeFirmProfile();
  alert('Firm profile saved. New projects will use these defaults.');
}

export function applyFirmProfileToNewProject(): void {
  const p = loadFirmProfile();
  if (!p || Object.keys(p).length === 0) return;
  if (p.entityType) { const node = document.getElementById('nq-entity-type') as HTMLSelectElement | null; if (node) node.value = p.entityType; }
  if (p.state) { const node = document.getElementById('nq-state') as HTMLSelectElement | null; if (node) node.value = p.state; }
  if (p.basis) { const node = document.getElementById('nq-basis') as HTMLSelectElement | null; if (node) node.value = p.basis; }
  if (p.depreciation) { const node = document.getElementById('nq-depreciation') as HTMLSelectElement | null; if (node) node.value = p.depreciation; }
  if (p.taxStatus) { const node = document.getElementById('nq-tax-status') as HTMLSelectElement | null; if (node) node.value = p.taxStatus; }
  if (p.inventory) { const node = document.getElementById('nq-inventory') as HTMLSelectElement | null; if (node) node.value = p.inventory; }
  if (p.usefulLives) { const node = document.getElementById('nq-useful-lives') as HTMLSelectElement | null; if (node) node.value = p.usefulLives; }
  if (p.revenueRec) { const node = document.getElementById('nq-revenue-recognition') as HTMLSelectElement | null; if (node) node.value = p.revenueRec; }
  if (p.cashEquiv) { const node = document.getElementById('nq-cash-equiv') as HTMLSelectElement | null; if (node) node.value = p.cashEquiv; }
}
